import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c218470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-order-guide" }
const _hoisted_2 = { class: "create-order-guide-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create-order-guide-content-title" }, "注文作成チェック", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create-order-guide-content-text" }, [
  /*#__PURE__*/_createTextVNode("各項目の設定状況を確認できます。未設定の場合は"),
  /*#__PURE__*/_createElementVNode("span", null, "赤色"),
  /*#__PURE__*/_createTextVNode("で表示されます。")
], -1))
const _hoisted_5 = { class: "create-order-guide-line" }
const _hoisted_6 = {
  key: 0,
  class: "guide-line-part"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "part-num active" }, "1")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-text active" }, "注文タイプ選択", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "guide-line-part" }
const _hoisted_11 = { class: "part-img" }
const _hoisted_12 = { class: "guide-line-part" }
const _hoisted_13 = { class: "part-img" }
const _hoisted_14 = { class: "guide-line-part" }
const _hoisted_15 = { class: "part-img" }
const _hoisted_16 = { class: "guide-line-part" }
const _hoisted_17 = { class: "part-img" }
const _hoisted_18 = { class: "guide-line-part" }
const _hoisted_19 = { class: "part-img" }
const _hoisted_20 = { class: "part-num" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-text" }, "注文作成", -1))
const _hoisted_22 = {
  key: 0,
  class: "create-order-guide-content-fixed"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create-order-guide-content-title" }, "注文作成チェック", -1))
const _hoisted_24 = { class: "create-order-guide-line" }
const _hoisted_25 = {
  key: 0,
  class: "guide-line-part"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-point active" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-text active" }, "注文タイプ選択", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "guide-line-part" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "guide-line-part" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "guide-line-part" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "guide-line-part" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "guide-line-part" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "part-point" }, [
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "part-text" }, "注文作成")
], -1))

import { onMounted, onUnmounted, ref, watch } from 'vue'
import bus from '@/util/useBus'
import { isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['mode'],
  setup(__props) {

const props = __props

const checkStatus = ref({
  currentStatus: 0,
  addressStatus: false,
  deliverStatus: false,
  chooseGoodsStatus: false,
  goodsAdditionStatus: false
})
watch(() => props.mode, () => {
  checkStatus.value = {
    currentStatus: 0,
    addressStatus: false,
    deliverStatus: false,
    chooseGoodsStatus: false,
    goodsAdditionStatus: false
  }
})
const isShow = ref(false)
const scrollFn = (e: any) => {
  if (e.target.scrollTop > 110 && !isShow.value) {
    isShow.value = true
  }
  if (e.target.scrollTop < 110 && isShow.value) {
    isShow.value = false
  }
}
let container: any = null
onMounted(() => {
  console.log('checkShopcartStatus', props.mode)
  bus.on('checkShopcartStatus', (status) => {
    console.log('checkShopcartStatus', status)
    checkStatus.value = status
  })
  container = document.querySelector('.scroll-container-outermost')

  container?.addEventListener('scroll', scrollFn)
})
onUnmounted(() => {

  container?.removeEventListener('scroll', scrollFn)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true),
        (__props.mode === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: _normalizeClass(["line-div", { active: true, error: checkStatus.value.currentStatus > 0 && !checkStatus.value.addressStatus }])
              }, null, 2),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["part-num", { active: checkStatus.value.addressStatus, error: checkStatus.value.currentStatus > 0 && !checkStatus.value.addressStatus }])
                  }, " 2", 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 0 && !checkStatus.value.addressStatus, active: checkStatus.value.addressStatus }])
                }, " お届け先情報 ", 2)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["line-div", { active: checkStatus.value.addressStatus, error: checkStatus.value.currentStatus > 1 && !checkStatus.value.addressStatus }])
              }, null, 2),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["part-num", { active: checkStatus.value.deliverStatus, error: checkStatus.value.currentStatus > 1 && !checkStatus.value.deliverStatus }])
                  }, " 3", 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 1 && !checkStatus.value.deliverStatus, active: checkStatus.value.deliverStatus }])
                }, " 発送オプション ", 2)
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["line-div", { active: checkStatus.value.deliverStatus || __props.mode === 0, error: __props.mode === 1 && checkStatus.value.currentStatus > 2 && !checkStatus.value.deliverStatus }])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass(["part-num", { active: checkStatus.value.goodsAdditionStatus, error: checkStatus.value.currentStatus > 3 && !checkStatus.value.goodsAdditionStatus }])
            }, _toDisplayString(__props.mode === 1 ? 4 : (_unref(isD2C)() ? 2 : 1)), 3)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 2 && !checkStatus.value.goodsAdditionStatus, active: checkStatus.value.goodsAdditionStatus }])
          }, " 商品選択・商品オプション", 2)
        ]),
        (__props.mode === 0 && _unref(isD2C)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", {
                class: _normalizeClass(["line-div", { active: checkStatus.value.goodsAdditionStatus, error: checkStatus.value.currentStatus > 3 && !checkStatus.value.goodsAdditionStatus }])
              }, null, 2),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["part-num", { active: checkStatus.value.goodsAdditionStatus, error: checkStatus.value.currentStatus > 3 && !checkStatus.value.goodsAdditionStatus }])
                  }, " 3", 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 3 && !checkStatus.value.goodsAdditionStatus, active: checkStatus.value.goodsAdditionStatus }])
                }, " 保管先倉庫", 2)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["line-div", { error: checkStatus.value.currentStatus > 4 && !checkStatus.value.goodsAdditionStatus }])
        }, null, 2),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(__props.mode === 1 ? 5 : (_unref(isD2C)() ? 4 : 2)), 1)
          ]),
          _hoisted_21
        ])
      ])
    ]),
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
              : _createCommentVNode("", true),
            (__props.mode === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["line-div", { active: true, error: checkStatus.value.currentStatus > 0 && !checkStatus.value.addressStatus }])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["part-point", { active: checkStatus.value.addressStatus, error: checkStatus.value.currentStatus > 0 && !checkStatus.value.addressStatus }])
                    }, _hoisted_31, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 0 && !checkStatus.value.addressStatus, active: checkStatus.value.addressStatus }])
                    }, " お届け先情報", 2)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["line-div", { active: checkStatus.value.addressStatus, error: checkStatus.value.currentStatus > 1 && !checkStatus.value.addressStatus }])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["part-point", { active: checkStatus.value.deliverStatus, error: checkStatus.value.currentStatus > 1 && !checkStatus.value.deliverStatus }])
                    }, _hoisted_34, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 1 && !checkStatus.value.deliverStatus, active: checkStatus.value.deliverStatus }])
                    }, " 発送オプション", 2)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["line-div", { active: checkStatus.value.deliverStatus || __props.mode === 0, error: __props.mode === 1 && checkStatus.value.currentStatus > 2 && !checkStatus.value.deliverStatus }])
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", {
                class: _normalizeClass(["part-point", { active: checkStatus.value.goodsAdditionStatus, error: checkStatus.value.currentStatus > 2 && !checkStatus.value.goodsAdditionStatus }])
              }, _hoisted_37, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 2 && !checkStatus.value.goodsAdditionStatus, active: checkStatus.value.goodsAdditionStatus }])
              }, " 商品選択・商品オプション", 2)
            ]),
            (__props.mode === 0 && _unref(isD2C)())
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["line-div", { active: checkStatus.value.chooseGoodsStatus, error: checkStatus.value.currentStatus > 3 && !checkStatus.value.chooseGoodsStatus }])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["part-point", { active: checkStatus.value.goodsAdditionStatus, error: checkStatus.value.currentStatus > 3 && !checkStatus.value.goodsAdditionStatus }])
                    }, _hoisted_40, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["part-text", { error: checkStatus.value.currentStatus > 3 && !checkStatus.value.goodsAdditionStatus, active: checkStatus.value.goodsAdditionStatus }])
                    }, " 保管先倉庫", 2)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["line-div", { error: checkStatus.value.currentStatus > 4 && !checkStatus.value.goodsAdditionStatus }])
            }, null, 2),
            _hoisted_41
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})